// @flow
//eslint-disable-next-line

import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { IMAGE_SRC, HELPER } from '../../../utils'

function MerchantLogo({ imgClasses }) {
	const { favicon, logo, store_name } = useSelector((state) => state.config.merchant)

	const [logoImage, setLogoImage] = useState(IMAGE_SRC.BSECURE_DEFAULT_LOGO)

	useEffect(() => {
		setLogoImage(logo)
		HELPER.setFavicon(favicon)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		//Check added to check if website_logo image is provided by api; If it is then only update website_logo else show default one.
		setLogoImage(logo)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [logo])

	useEffect(() => {
		//Check added to check if favicon image is provided by api; If it is then only update favicon.
		HELPER.setFavicon(favicon)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [favicon])
	/*
  const logoClicked = () => {
    const hostname = window.location.hostname
    const pathname = HISTORY.location.pathname;
    if (hostname.match(process.env.REACT_APP_DOMAIN_URL)) {
      const bShopRoutes = [ROUTE_CONSTANTS.BASE + catalogue_key, ROUTE_CONSTANTS.CART];
      if (!HELPER.isEmpty(catalogue_key) && bShopRoutes.includes(pathname)) {
        // user came from a bookmark or an external link
        HISTORY.push(ROUTE_CONSTANTS.BASE + catalogue_key)
      }
      else if (!bShopRoutes.includes(pathname)) {
        // user came from a bookmark or an external link
        HISTORY.push(ROUTE_CONSTANTS.BSECURE_MALL)
      }
    }
    else {
      // user came from a bookmark or an external link
      HISTORY.push(ROUTE_CONSTANTS.BASE)
    }
  };
  */
	return (
		<img
			src={logoImage}
			className={imgClasses}
			alt={store_name + ' logo'} /*onClick={logoClicked}*/
		/>
	)
}

export default MerchantLogo
